var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSandglass2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_2110_273759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.660492 15.4696C-0.220163 13.941 -0.220164 12.059 0.660492 10.5304L5.29982 2.47756C6.18294 0.944662 7.81739 9.32214e-08 9.58648 1.14318e-07L18.8467 2.24745e-07C20.6158 2.45841e-07 22.2503 0.944662 23.1334 2.47756L27.7727 10.5304C28.6534 12.059 28.6534 13.941 27.7727 15.4696L23.1334 23.5224C22.2503 25.0553 20.6158 26 18.8467 26L9.58648 26C7.81739 26 6.18294 25.0553 5.29982 23.5224L0.660492 15.4696Z",
    fill: "#19191E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4563 12.0591C17.2509 11.3346 18.3112 10.3678 18.5054 8.16294C18.5234 7.95918 18.6905 7.79687 18.895 7.79687H18.9067C19.111 7.79687 19.2766 7.63123 19.2766 7.42689C19.2766 7.22256 19.111 7.05692 18.9067 7.05692H10.0272C9.82287 7.05692 9.65723 7.22256 9.65723 7.42689C9.65723 7.63123 9.82287 7.79687 10.0272 7.79687H10.0388C10.2434 7.79687 10.4105 7.95918 10.4284 8.16294C10.6226 10.3678 11.683 11.3346 12.4776 12.0591C13.0392 12.5712 13.357 12.8846 13.357 13.3712C13.357 13.8578 13.0392 14.1712 12.4776 14.6833C11.683 15.4078 10.6226 16.3746 10.4284 18.5795C10.4105 18.7832 10.2434 18.9455 10.0388 18.9455H10.0272C9.82287 18.9455 9.65723 19.1112 9.65723 19.3155C9.65723 19.5198 9.82287 19.6855 10.0272 19.6855H18.9067C19.111 19.6855 19.2766 19.5198 19.2766 19.3155C19.2766 19.1112 19.111 18.9455 18.9067 18.9455H18.895C18.6905 18.9455 18.5234 18.7832 18.5054 18.5795C18.3112 16.3746 17.2509 15.4078 16.4563 14.6833C15.8947 14.1712 15.5769 13.8578 15.5769 13.3712C15.5769 12.8846 15.8947 12.5712 16.4563 12.0591ZM14.097 15.7911C14.097 15.9969 13.9497 16.1693 13.7596 16.248L12.642 16.7104C12.2114 16.8886 11.8235 16.4784 12.1133 16.1135C12.3917 15.763 12.6956 15.4858 12.9761 15.2301C13.5525 14.7046 14.097 14.2082 14.097 13.3712V15.7911ZM15.9578 15.2301C16.2382 15.4858 16.5421 15.7629 16.8205 16.1135C17.1104 16.4784 16.7224 16.8886 16.2918 16.7104L15.1743 16.2479C14.9841 16.1693 14.8369 15.9969 14.8369 15.7911V13.3712C14.8369 14.2082 15.3813 14.7046 15.9578 15.2301ZM11.8436 9.52343C11.6248 9.52343 11.426 9.3894 11.3643 9.17956C11.2907 8.92901 11.2322 8.65331 11.193 8.34806C11.1546 8.04915 11.3976 7.79687 11.699 7.79687H17.2348C17.5362 7.79687 17.7792 8.04915 17.7409 8.34806C17.7017 8.65332 17.6432 8.92902 17.5695 9.17958C17.5078 9.38941 17.309 9.52343 17.0903 9.52343H11.8436Z",
    fill: "#E9BE5C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_2110_273759",
    x: -2.35461,
    y: -2.35461,
    width: 33.1423,
    height: 30.7092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.17731
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2110_273759"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2110_273759",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.362248
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.181124
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2110_273759"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.07911
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2110_273759",
    result: "effect3_innerShadow_2110_273759"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandglass2);
export default __webpack_public_path__ + "static/media/sandglass2.9970dd386982d6584d1943cc5615f86a.svg";
export { ForwardRef as ReactComponent };